function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExclamation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "Layer_1",
  width: 20.611,
  height: 17.995,
  x: 0,
  y: 0,
  viewBox: "0 0 20.611 17.995"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.21.083 0 17.767h20.42zm.004 15.806c-.904 0-1.521-.643-1.521-1.524 0-.907.625-1.532 1.517-1.532.903 0 1.506.625 1.517 1.532 0 .88-.6 1.524-1.513 1.524m1.158-4.095H9.19l-.356-6.156h2.892z",
  style: {
    fill: "#000"
  }
}));
export default SvgExclamation;